import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RxFor } from '@rx-angular/template/for';
import { AssignmentOptimizerKpiDto } from '@wilson/interfaces';
import { SharedComponentsModule } from '@wilson/shared-components';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { TimelineDraftModeKpiTranslationHelperService } from '../../services/timeline-draft-mode-kpi-translation-helper.service';
import { Observable, of } from 'rxjs';
import { AssignmentsGanttChartService } from '@wilson/shift-timeline/assignments-gantt-chart';

@Component({
  selector: 'wilson-optimizer-assignments-user-kpis',
  templateUrl: './optimizer-assignments-user-kpis.component.html',
  styleUrls: ['./optimizer-assignments-user-kpis.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    SharedComponentsModule,
    NzTooltipModule,
    NzSkeletonModule,
    NzDividerModule,
    TranslateModule,
    RxFor,
  ],
  providers: [AssignmentsGanttChartService],
})
export class OptimizerAssignmetnsUserKpisComponent {
  protected PIXEL_ADJUSTMENT = 20;
  private readonly timelineDraftModeKpiTranslationHelperService = inject(
    TimelineDraftModeKpiTranslationHelperService,
  );
  assignmentsGanttChartService = inject(AssignmentsGanttChartService);
  protected userKpisWithTranslations$: Observable<
    (AssignmentOptimizerKpiDto & {
      translatedName: string;
      translatedDescription: string;
    })[]
  > = of([]);

  @Input() set userKpis(value: AssignmentOptimizerKpiDto[] | undefined) {
    if (value) {
      this.userKpisWithTranslations$ =
        this.timelineDraftModeKpiTranslationHelperService.transformDataToTranslatedData(
          value,
        );
    }
  }
  @Input() isLoadingKpiValue = false;
}
